module.exports = __webpack_public_path__ + "img/header-scholarship.a265cfd4.png";